import { addYears, isBlank, isPersonNameValid } from './applicantFormatters.js'

export const FIELD_LIMIT_LABELS = {
  operatorComment: 'Дополнительная информация: комментарий оператора',
  eserviceNumber: 'Личные данные: номер заявления ЕПГУ',
  lastname: 'Личные данные: фамилия',
  firstname: 'Личные данные: имя',
  patronymic: 'Личные данные: отчество',
  phone: 'Личные данные: телефон',
  snils: 'Личные данные: СНИЛС',
  email: 'Личные данные: email',
  citizenship: 'Личные данные: гражданство',
  birthPlace: 'Личные данные: место рождения',
  'passport.series': 'Документ: серия',
  'passport.number': 'Документ: номер',
  'passport.issuedBy': 'Документ: кем выдан',
  'passport.subdivisionCode': 'Документ: код подразделения',
  notes: 'Дополнительная информация: примечания',
  workPlace: 'Дополнительная информация: место работы',
  position: 'Дополнительная информация: должность',
  experience: 'Дополнительная информация: стаж',
  militaryOffice: 'Дополнительная информация: военкомат',
  'educationInstitutionAddress.institutionName': 'Аттестат: наименование образовательного учреждения',
  'educationInstitutionAddress.country': 'Аттестат: страна образовательного учреждения',
  'educationInstitutionAddress.region': 'Аттестат: область образовательного учреждения',
  'educationInstitutionAddress.district': 'Аттестат: район образовательного учреждения',
  'educationInstitutionAddress.locality': 'Аттестат: населенный пункт образовательного учреждения',
  educationDocumentSeries: 'Аттестат: серия документа',
  educationDocumentNumber: 'Аттестат: номер документа',
  'payers.*.lastname': 'Плательщики: фамилия',
  'payers.*.firstname': 'Плательщики: имя',
  'payers.*.patronymic': 'Плательщики: отчество',
  'payers.*.email': 'Плательщики: email',
  'payers.*.phone': 'Плательщики: телефон',
  'payers.*.snils': 'Плательщики: СНИЛС',
  'payers.*.workPlace': 'Плательщики: место работы',
  'payers.*.passport.series': 'Плательщики: серия документа',
  'payers.*.passport.number': 'Плательщики: номер документа',
  'payers.*.passport.issuedBy': 'Плательщики: кем выдан документ',
  'payers.*.passport.subdivisionCode': 'Плательщики: код подразделения',
  'acceptedDocuments.*.additionalText': 'Документы: комментарий к принятому документу',
  'registrationAddress.data.postalCode': 'Документ и адрес: индекс адреса регистрации',
  'registrationAddress.data.postal_code': 'Документ и адрес: индекс адреса регистрации',
  'registrationAddress.data.region': 'Документ и адрес: регион адреса регистрации',
  'registrationAddress.data.region_type': 'Документ и адрес: тип региона адреса регистрации',
  'registrationAddress.data.area': 'Документ и адрес: район адреса регистрации',
  'registrationAddress.data.area_type': 'Документ и адрес: тип района адреса регистрации',
  'registrationAddress.data.city': 'Документ и адрес: город адреса регистрации',
  'registrationAddress.data.city_type': 'Документ и адрес: тип города адреса регистрации',
  'registrationAddress.data.settlement': 'Документ и адрес: населенный пункт адреса регистрации',
  'registrationAddress.data.settlement_type': 'Документ и адрес: тип населенного пункта адреса регистрации',
  'registrationAddress.data.street': 'Документ и адрес: улица адреса регистрации',
  'registrationAddress.data.street_type': 'Документ и адрес: тип улицы адреса регистрации',
  'registrationAddress.data.house': 'Документ и адрес: дом адреса регистрации',
  'registrationAddress.data.house_type': 'Документ и адрес: тип дома адреса регистрации',
  'registrationAddress.data.block': 'Документ и адрес: корпус адреса регистрации',
  'registrationAddress.data.block_type': 'Документ и адрес: тип корпуса адреса регистрации',
  'registrationAddress.data.apartment': 'Документ и адрес: квартира адреса регистрации',
  'registrationAddress.data.apartment_type': 'Документ и адрес: тип квартиры адреса регистрации',
  'registrationAddress.data.kladr': 'Документ и адрес: КЛАДР адреса регистрации',
  'registrationAddress.data.fias': 'Документ и адрес: ФИАС адреса регистрации',
  'registrationAddress.data.fias_id': 'Документ и адрес: ФИАС адреса регистрации',
  'actualAddress.data.postalCode': 'Документ и адрес: индекс фактического адреса',
  'actualAddress.data.postal_code': 'Документ и адрес: индекс фактического адреса',
  'actualAddress.data.region': 'Документ и адрес: регион фактического адреса',
  'actualAddress.data.region_type': 'Документ и адрес: тип региона фактического адреса',
  'actualAddress.data.area': 'Документ и адрес: район фактического адреса',
  'actualAddress.data.area_type': 'Документ и адрес: тип района фактического адреса',
  'actualAddress.data.city': 'Документ и адрес: город фактического адреса',
  'actualAddress.data.city_type': 'Документ и адрес: тип города фактического адреса',
  'actualAddress.data.settlement': 'Документ и адрес: населенный пункт фактического адреса',
  'actualAddress.data.settlement_type': 'Документ и адрес: тип населенного пункта фактического адреса',
  'actualAddress.data.street': 'Документ и адрес: улица фактического адреса',
  'actualAddress.data.street_type': 'Документ и адрес: тип улицы фактического адреса',
  'actualAddress.data.house': 'Документ и адрес: дом фактического адреса',
  'actualAddress.data.house_type': 'Документ и адрес: тип дома фактического адреса',
  'actualAddress.data.block': 'Документ и адрес: корпус фактического адреса',
  'actualAddress.data.block_type': 'Документ и адрес: тип корпуса фактического адреса',
  'actualAddress.data.apartment': 'Документ и адрес: квартира фактического адреса',
  'actualAddress.data.apartment_type': 'Документ и адрес: тип квартиры фактического адреса',
  'actualAddress.data.kladr': 'Документ и адрес: КЛАДР фактического адреса',
  'actualAddress.data.fias': 'Документ и адрес: ФИАС фактического адреса',
  'actualAddress.data.fias_id': 'Документ и адрес: ФИАС фактического адреса',
  'payers.*.registrationAddress.data.postalCode': 'Плательщики: индекс адреса регистрации',
  'payers.*.registrationAddress.data.postal_code': 'Плательщики: индекс адреса регистрации',
  'payers.*.registrationAddress.data.region': 'Плательщики: регион адреса регистрации',
  'payers.*.registrationAddress.data.region_type': 'Плательщики: тип региона адреса регистрации',
  'payers.*.registrationAddress.data.area': 'Плательщики: район адреса регистрации',
  'payers.*.registrationAddress.data.area_type': 'Плательщики: тип района адреса регистрации',
  'payers.*.registrationAddress.data.city': 'Плательщики: город адреса регистрации',
  'payers.*.registrationAddress.data.city_type': 'Плательщики: тип города адреса регистрации',
  'payers.*.registrationAddress.data.settlement': 'Плательщики: населенный пункт адреса регистрации',
  'payers.*.registrationAddress.data.settlement_type': 'Плательщики: тип населенного пункта адреса регистрации',
  'payers.*.registrationAddress.data.street': 'Плательщики: улица адреса регистрации',
  'payers.*.registrationAddress.data.street_type': 'Плательщики: тип улицы адреса регистрации',
  'payers.*.registrationAddress.data.house': 'Плательщики: дом адреса регистрации',
  'payers.*.registrationAddress.data.house_type': 'Плательщики: тип дома адреса регистрации',
  'payers.*.registrationAddress.data.block': 'Плательщики: корпус адреса регистрации',
  'payers.*.registrationAddress.data.block_type': 'Плательщики: тип корпуса адреса регистрации',
  'payers.*.registrationAddress.data.apartment': 'Плательщики: квартира адреса регистрации',
  'payers.*.registrationAddress.data.apartment_type': 'Плательщики: тип квартиры адреса регистрации',
  'payers.*.registrationAddress.data.kladr': 'Плательщики: КЛАДР адреса регистрации',
  'payers.*.registrationAddress.data.fias': 'Плательщики: ФИАС адреса регистрации',
  'payers.*.registrationAddress.data.fias_id': 'Плательщики: ФИАС адреса регистрации'
}

export function addRequiredIssue(issues, value, label, required = true) {
  if (required && isBlank(value)) {
    issues.push(label)
  }
}

export function addNameIssue(issues, value, label, required) {
  if (isBlank(value)) {
    if (required) {
      issues.push(label)
    }
    return
  }

  if (!isPersonNameValid(value)) {
    issues.push(`${label}: допустимы кириллица, пробел, дефис и апостроф`)
  }
}

/**
 * Checks whether the shared address component contains structured data.
 */
export function hasAddressData(address) {
  const data = address && address.data
    ? address.data
    : {}

  return Object.values(data).some(value => (
    value !== null &&
    value !== undefined &&
    String(value).trim() !== ''
  ))
}

/**
 * Adds a date validation issue to the summary checklist.
 */
export function addDateIssue(issues, value, label, min, max, required = true) {
  if (isBlank(value)) {
    if (required) {
      issues.push(label)
    }
    return
  }

  if (value < min) {
    issues.push(`${label}: дата раньше допустимой`)
  } else if (value > max) {
    issues.push(`${label}: дата позже допустимой`)
  }
}

/**
 * Adds previous education year validation to the summary checklist.
 */
export function addGraduationYearIssue(issues, value, required = true) {
  const normalizedValue = String(value || '')
  const minYear = addYears(new Date(), -100).getFullYear()
  const maxYear = new Date().getFullYear()

  if (isBlank(normalizedValue)) {
    if (required) {
      issues.push('Аттестат: год окончания учебного заведения')
    }
  } else if (!/^\d{4}$/.test(normalizedValue)) {
    issues.push('Аттестат: год окончания должен быть в формате ГГГГ')
  } else if (Number(normalizedValue) < minYear) {
    issues.push('Аттестат: год окончания старше допустимого периода')
  } else if (Number(normalizedValue) > maxYear) {
    issues.push('Аттестат: год окончания позже текущего года')
  }
}

export function isEmptyPayerData(payer) {
  if (!payer) {
    return true
  }

  const passport = payer.passport || {}
  const address = payer.registrationAddress || {}
  const values = [
    payer.representative,
    payer.lastname,
    payer.firstname,
    payer.patronymic,
    payer.gender,
    payer.snils,
    payer.birthDate,
    payer.email,
    payer.phone,
    payer.workPlace,
    passport.documentType,
    passport.series,
    passport.number,
    passport.issueDate,
    passport.subdivisionCode,
    passport.issuedBy
  ]

  const hasValue = values.some(value => (
    value !== null &&
    value !== undefined &&
    String(value).trim() !== '' &&
    String(value).trim() !== '+7'
  ))

  return !hasValue && !hasAddressData(address)
}

export function hasFilledPayer(payers) {
  return payers.some(payer => !isEmptyPayerData(payer))
}

export function getDictionaryName(items, itemId) {
  const item = items.find(value => String(value.id) === String(itemId))

  return item ? item.name : itemId
}

export function collectFieldLengthIssues(formData, fieldLimits) {
  const issues = []

  Object.entries(fieldLimits || {}).forEach(([path, limit]) => {
    const maxLength = Number(limit && limit.maxLength ? limit.maxLength : 0)

    if (maxLength <= 0) {
      return
    }

    getValuesByPath(formData, path).forEach(value => {
      if (isBlank(value) || typeof value === 'object') {
        return
      }

      const text = String(value)
      if (text.length > maxLength) {
        const label = FIELD_LIMIT_LABELS[path] || path
        issues.push(`${label}: не больше ${maxLength} символов`)
      }
    })
  })

  return issues
}

export function getValuesByPath(source, path) {
  return String(path || '')
    .split('.')
    .reduce((values, segment) => {
      const nextValues = []

      values.forEach(value => {
        if (value === null || value === undefined) {
          return
        }

        if (segment === '*') {
          if (Array.isArray(value)) {
            nextValues.push(...value)
          } else if (typeof value === 'object') {
            nextValues.push(...Object.values(value))
          }
          return
        }

        if (typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, segment)) {
          nextValues.push(value[segment])
        }
      })

      return nextValues
    }, [source])
}
